import { render, staticRenderFns } from "./ViewConfirmOrderForm.vue?vue&type=template&id=2c1ee1ce&scoped=true&"
import script from "./ViewConfirmOrderForm.vue?vue&type=script&lang=js&"
export * from "./ViewConfirmOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./ViewConfirmOrderForm.vue?vue&type=style&index=0&id=2c1ee1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ee1ce",
  null
  
)

export default component.exports